import React from 'react';
import {
  usePopupState,
  bindTrigger,
  bindMenu,
} from 'material-ui-popup-state/hooks';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';

const Dropdown = ({
  id,
  options,
  onSelect,
  children,
  anchor = 'right',
  maxHeight = 300,
}) => {
  const menuState = usePopupState({ popupId: id, variant: 'popover' });

  const handleClick = (type, originalClick, autoClose) => (e) => {
    if (autoClose !== false) {
      menuState.close();
    }
    if (onSelect) {
      onSelect(type);
    }
    if (originalClick) {
      return originalClick(e, type);
    }
  };

  return (
    <>
      {React.cloneElement(children, bindTrigger(menuState))}
      <Menu
        TransitionProps={{
          unmountOnExit: true,
        }}
        {...bindMenu(menuState)}
        MenuListProps={{
          sx: {
            minWidth: Math.max(150, menuState.anchorEl?.offsetWidth),
            maxHeight,
          },
        }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: anchor,
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: anchor,
        }}
      >
        {options.map(
          ({
            key,
            onClick,
            icon,
            children,
            label,
            destructive,
            autoClose = true,
            ...other
          }) => {
            const isString = typeof children === 'string';
            if (label ?? isString) {
              return (
                <MenuItem
                  key={key}
                  onClick={handleClick(key, onClick, autoClose)}
                  sx={{
                    fontWeight: 500,
                    color: destructive ? 'error.main' : 'text.primary',
                  }}
                  {...other}
                >
                  {icon && <ListItemIcon>{icon}</ListItemIcon>}
                  {label ?? children}
                </MenuItem>
              );
            }
            return React.cloneElement(children, {
              onClose: menuState.close,
              isOpen: menuState.isOpen,
            });
          },
        )}
      </Menu>
    </>
  );
};

export default Dropdown;
